module.exports = __webpack_public_path__ + "static/media/slider_4_en_sm.2abeebf7.svg";